

export const schoolConstants = {

    LOADING : 'LOADING',
    CLEAN_LEVELS: 'CLEAN_LEVELS',

    SET_CURRENT_CALENDAR: 'SET_CURRENT_CALENDAR',
 
    SHOW_CALENDAR_LEVELS: 'SHOW_CALENDAR_LEVELS',
    SHOW_LEVEL_2: 'SHOW_LEVEL_2',
    SHOW_LEVEL_3: 'SHOW_LEVEL_3',

    SHOW_LEVEL_COURSES:  'SHOW_LEVEL_COURSES',

    LOAD_ENROLL_FILE: 'LOAD_ENROLL_FILE',
    DELETE_ENROLL_FILE: 'DELETE_ENROLL_FILE',
    ENROLL_STUDENT_COURSE: 'ENROLL_STUDENT_COURSE'
};